import iconArrowUp from "assets/images/common/arrow-up.svg";
import iconArrowDown from "assets/images/common/arrow-down.svg";

const sorts = [
  {
    name: "등록순",
    value: {
      item: "createdAt",
      range: "desc",
    },
    icon: iconArrowUp,
  },
  {
    name: "가격순",
    value: {
      item: "price",
      range: "asc",
    },
    icon: iconArrowDown,
  },
  {
    name: "가격순",
    value: {
      item: "price",
      range: "desc",
    },
    icon: iconArrowUp,
  },
];

const productSort = {
  ai: [
    {
      name: "유사순",
      value: {
        item: "similarity",
        range: "desc",
      },
      icon: iconArrowUp,
    },
    ...sorts,
  ],
  general: sorts,
};

export default productSort;
